import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import type {
  ProductType,
  PurchaseOrderType,
} from '@xing-com/crate-common-graphql-types';
import { spaceS } from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

import { OfferBoxButton } from './offer-box-button';

export interface PurchaseButtonProps {
  disabled: boolean;
  product: ProductType;
  orderType: PurchaseOrderType;
  id: string;
  duration: number;
  className?: string;
}

export const PurchaseButton: React.FC<PurchaseButtonProps> = ({
  disabled,
  product,
  orderType,
  id,
  duration,
  className = '',
}) => {
  return (
    <div className={className}>
      <ButtonWrapper disabled={disabled}>
        <OfferBoxButton
          product={product}
          orderType={orderType}
          activeContractId={disabled ? 'no-contract-id' : id}
          duration={duration}
        />
      </ButtonWrapper>
      {orderType === 'UPSELL' && (
        <StyledMeta size="xsmall" style={{ textAlign: 'center' }}>
          <FormattedMessage
            id="UPSELL_PURCHASE_MONTHLY_CANCELLATION_INFO"
            values={{ duration }}
          />
        </StyledMeta>
      )}
    </div>
  );
};

const ButtonWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spaceS};

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`;

const StyledMeta = styled(Meta)`
  margin: 0;
`;
